import { useReveal } from "../hooks/useReveal";

export const Hero = () => {
  const ref = useReveal();
  return (
    <section id="hello" className="relative pt-24 sm:pt-28 pb-10 sm:pb-16 px-5">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-6 sm:mb-10">
          <span className="mono text-[10px] sm:text-xs tracking-widest uppercase text-[color:var(--mr-muted)]">
            [ creative · agency · marketing ]
          </span>
          <span className="mono text-[10px] sm:text-xs tracking-widest uppercase text-[color:var(--mr-muted)] hidden sm:inline">
            est · valencia
          </span>
        </div>

        <div
          ref={ref}
          className="reveal relative mx-auto w-full rounded-[28px] overflow-hidden bg-black"
          style={{ maxWidth: 720, aspectRatio: "16/10" }}
          data-testid="hero-video"
        >
          <video
            className="w-full h-full object-cover"
            src="/assets/hero-logo.mp4"
            autoPlay
            muted
            loop
            playsInline
          />
          <div className="absolute inset-0 ring-1 ring-white/10 rounded-[28px] pointer-events-none" />
        </div>

        <div className="mt-8 sm:mt-10 max-w-2xl">
          <p className="mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[color:var(--mr-fuchsia)] mb-3">
            · modoredes creative agency ·
          </p>
          <p className="text-base sm:text-lg leading-relaxed text-[color:var(--mr-ink-soft)] font-medium">
            Somos una agencia creativa de <span className="text-[color:var(--mr-purple)] font-bold">marketing 360</span> que acompaña a las marcas desde la estrategia hasta la ejecución, cuidando que cada idea, pieza y acción tenga coherencia con su esencia y sus objetivos.
          </p>
        </div>
      </div>
    </section>
  );
};
